<form class="signature-tab-form" [formGroup]="SignatureTab">
  <div class="normalFont">{{signatureText}}</div>
  <div class="italicFont">{{agreeText}}</div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="first-name-width">
      <mat-label class="boldlabel">First Name</mat-label>
      <input matInput placeholder="First Name" formControlName="firstName" value="">
    </mat-form-field>
    <mat-form-field class="middle-width">
      <mat-label>Middle Initial</mat-label>
      <input matInput placeholder="Middle Initial" formControlName="middleName" value="">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="first-name-width">
      <mat-label class="boldlabel">Last Name</mat-label>
      <input matInput placeholder="Last Name" formControlName="lastName" value="">
    </mat-form-field>
    <mat-form-field class="middle-width">
      <mat-label>Suffix</mat-label>
      <input matInput placeholder="Suffix" formControlName="suffix" value="">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="50px">
    <mat-form-field class="title-width">
      <mat-label class="">Title</mat-label>
      <input matInput placeholder="Title" formControlName="title" value="">
    </mat-form-field>
    <mat-checkbox [ngClass]="SignatureTab.controls['iCertify'].invalid ? 'errorMsg' : ''" class="mailingAddress boldlabel" formControlName="iCertify">I Certify</mat-checkbox>
  </div>
  <div class="italicFont"></div>
</form>
<!-- Suffix -->